import { escapeCsvCell } from "@/shared/utils/csv";

import type { OtcSellOrder } from "../types/cryptoSell.types";

export interface CryptoSellCsvLabels {
  columns: string[];
  status: (sale: OtcSellOrder) => string;
  network: (sale: OtcSellOrder) => string;
}

/** Money stays the raw decimal string so the file re-imports losslessly. */
export function buildCryptoSellCsv(sales: OtcSellOrder[], labels: CryptoSellCsvLabels): string {
  const lines = sales.map((sale) =>
    [
      escapeCsvCell(sale.id),
      sale.created_at,
      escapeCsvCell(labels.status(sale)),
      sale.deposit.amount,
      escapeCsvCell(sale.deposit.currency),
      escapeCsvCell(labels.network(sale)),
      escapeCsvCell(sale.deposit.tx_hash),
      sale.price.value,
      sale.proceeds.paid_amount ?? sale.proceeds.amount,
      sale.credit.fee_total ?? "",
      sale.credit.amount ?? "",
      escapeCsvCell(sale.proceeds.currency),
      escapeCsvCell(sale.payout_key),
      escapeCsvCell(sale.refund_address),
      escapeCsvCell(sale.concept),
      sale.completed_at ?? "",
      sale.refunded_at ?? "",
    ].join(","),
  );

  return [labels.columns.map(escapeCsvCell).join(","), ...lines].join("\n");
}
